import { MiddleName } from '@dreryk/person-name-common-api';

import { FormContextValues } from '@dreryk/react-common';
import { TextInput } from '@dreryk/react-components';

import { patientTranslationKeys } from '../../translations';

type MiddleNameFieldProps = {
   readonly register: FormContextValues['register'];
};

export const MiddleNameField = (props: MiddleNameFieldProps): JSX.Element => {
   return (
      <TextInput
         controller={props.register('middleName', {
            maxLength: MiddleName.MAX_LENGTH,
         })}
         label={patientTranslationKeys.middleName}
         testId={'middleName'}
      />
   );
};
